// src/i18n.js
const translations = {
  zh: {
    // 通用
    appName: 'SMA超級智能體',
    connectWallet: '連接錢包',
    disconnect: '斷開連接',
    refresh: '刷新',
    maintenance: '維護中',
    copied: '已複製',
    copyFailed: '複製失敗',
    pleaseConnectWallet: '請先連接錢包',
    pleaseEnterAmount: '請輸入數量',
    pleaseEnterValidAddress: '請輸入有效地址',
    enterAmount: '輸入數量',
    enterAddress: '輸入錢包地址',
    close: '關閉',
    loading: '加載中...',
    
    // 餘額卡片
    usdtBalance: 'USDT餘額',
    smaBalance: 'SMA餘額',
    currentPrice: '當前價格',
    marketPrice: '市場價',
    
    // 邀請碼
    inviteCode: '邀請碼',
    generateInviteCode: '生成邀請碼',
    copyInviteLink: '複製邀請連結',
    generating: '生成中...',
    
    // 我的資產
    myAssets: '我的資產',
    depositPrincipal: '存款本金',
    remainingPrincipal: '剩餘本金',
    pendingReward: '待領獎勵',
    totalReward: '累計獎勵',
    claimReward: '領取獎勵',
    claiming: '領取中...',
    
    // 存款/提款
    deposit: '存款',
    depositing: '存款中...',
    withdraw: '提款',
    withdrawing: '提款中...',
    depositSuccess: '存款成功',
    depositFailed: '存款失敗',
    withdrawSuccess: '提款成功',
    withdrawFailed: '提款失敗',
    claimSuccess: '領取成功',
    claimFailed: '領取失敗',
    
    // 綁定推薦
    bindReferral: '綁定推薦人',
    bindReferralDesc: '綁定推薦人地址',
    binding: '綁定中...',
    bindSuccess: '綁定成功',
    bindFailed: '綁定失敗',
    generateCodeSuccess: '邀請碼生成成功',
    generateCodeFailed: '邀請碼生成失敗',
    
    // 推薦獎勵
    recommendReward: '推薦獎勵',
    earnedReferralReward: '已獲得推薦獎勵',
    referralRewardCap: '推薦獎勵上限',
    remainingClaimable: '可領取剩餘',
    usageProgress: '使用進度',
    tip: '提示：推薦獎勵上限為淨存款的2倍',
    
    // 節點
    becomeNode: '成為節點',
    nodeBadge: '節點',
    nodeTitle: '節點購買',
    nodePrice: '3,000 USDT',
    nodeDesc: '購買後享受節點權益',
    nodeApply: '立即購買',
    nodeProcessing: '處理中...',
    nodeSuccess: '購買成功',
    paymentFailed: '支付失敗',
    nodeAgree: '我已閱讀並同意節點協議',
    nodeBenefits: '節點權益',
    nodeBenefit1: '每日分紅',
    nodeBenefit2: '推薦獎勵',
    nodeBenefit3: '礦池收益',
    nodeBenefit4: '治理投票權',
    nodeAddressLabel: '收款地址',
    
    // 節點面板
    nodePanelTitle: '節點面板',
    nodePoolInfo: '節點池資訊',
    pendingTotal: '待發放總額',
    nextDistribution: '下次分配',
    myEarnings: '我的收益',
    miningReward: '挖礦獎勵',
    claimedNodeReward: '已領取節點獎勵',
    remainingCap: '剩餘上限',
    periodContribution: '本期貢獻',
    estimatedNext: '預計下次獲得',
    distributionSoon: '即將分配',
    
    // 礦池
    miningPool: '礦池',
    addLiquidity: '添加流動性',
    addingLiquidity: '添加中...',
    
    // 礦池面板
    poolPanelTitle: '礦池面板',
    totalPoolReward: '礦池獎勵',
    teamTotalMining: '團隊總挖礦',
    
    // 矿池健康度监控
    poolHealthTitle: '礦池健康度監控',
    qualifiedLabel: '✅ 達標',
    notQualifiedLabel: '⚠️ 不達標',
    periodAssessment: '第 {period} 期考核',
    remainingDaysText: '剩餘 {days} 天',
    teamTotalMining: '傘下總挖礦',
    periodRequirementText: '本期要求',
    progressText: '進度: {percent}%',
    childPoolsTitle: '📌 下級礦池（業績已扣除）',
    notQualifiedWarning: '⚠️ 業績不達標！剩餘 {days} 天內需達到 {requirement} SMA，否則將取消礦池資格。',
    soonExpireWarning: '⏰ 距離下次考核僅剩 {days} 天，下期要求 {nextRequirement} SMA',
    
    // 團隊
    teamNetwork: '團隊網絡',
    
    // LP分紅
    lpDividends: 'LP 分紅',
    pendingDividends: '待領取分紅',
    claimDividends: '領取分紅',
    claimingDividends: '領取中...',
    dividendsTip: '💡 只有添加流動性（LP）的用戶才能獲得分紅',
    
    // 彈窗
    bindReferralModal: '綁定推薦人',
    enterInviteCode: '請輸入邀請碼',
    inviteCodePlaceholder: '請輸入6位邀請碼',
    pleaseEnterInviteCode: '請輸入邀請碼',
    skip: '暫不綁定',
    bind: '綁定',
    
    // 治理面板
    governanceTitle: '🗳️ 治理投票',
    memberCountText: '位成員',
    createProposal: '創建提案',
    noActiveProposals: '暫無進行中的提案',
    proposalId: '提案編號',
    target: '目標地址',
    amount: '金額',
    status: '狀態',
    votes: '票數',
    execute: '執行',
    cancel: '取消',
    active: '進行中',
    executed: '已執行',
    cancelled: '已取消',
    yesVotes: '贊成票',
    noVotes: '反對票',
    requiredVotes: '所需票數',
  },
  en: {
    // Common
    appName: 'Super Culture Agent',
    connectWallet: 'Connect Wallet',
    disconnect: 'Disconnect',
    refresh: 'Refresh',
    maintenance: 'Maintenance',
    copied: 'Copied',
    copyFailed: 'Copy failed',
    pleaseConnectWallet: 'Please connect wallet first',
    pleaseEnterAmount: 'Please enter amount',
    pleaseEnterValidAddress: 'Please enter valid address',
    enterAmount: 'Enter amount',
    enterAddress: 'Enter address',
    close: 'Close',
    loading: 'Loading...',
    
    // Balance cards
    usdtBalance: 'USDT Balance',
    smaBalance: 'SMA Balance',
    currentPrice: 'Current Price',
    marketPrice: 'Market Price',
    
    // Invite code
    inviteCode: 'Invite Code',
    generateInviteCode: 'Generate Code',
    copyInviteLink: 'Copy Link',
    generating: 'Generating...',
    
    // My assets
    myAssets: 'My Assets',
    depositPrincipal: 'Deposit',
    remainingPrincipal: 'Remaining',
    pendingReward: 'Pending Reward',
    totalReward: 'Total Reward',
    claimReward: 'Claim',
    claiming: 'Claiming...',
    
    // Deposit/Withdraw
    deposit: 'Deposit',
    depositing: 'Depositing...',
    withdraw: 'Withdraw',
    withdrawing: 'Withdrawing...',
    depositSuccess: 'Deposit success',
    depositFailed: 'Deposit failed',
    withdrawSuccess: 'Withdraw success',
    withdrawFailed: 'Withdraw failed',
    claimSuccess: 'Claim success',
    claimFailed: 'Claim failed',
    
    // Bind referral
    bindReferral: 'Bind Referrer',
    bindReferralDesc: 'Referrer Address',
    binding: 'Binding...',
    bindSuccess: 'Bind success',
    bindFailed: 'Bind failed',
    generateCodeSuccess: 'Code generated',
    generateCodeFailed: 'Code failed',
    
    // Referral rewards
    recommendReward: 'Referral Rewards',
    earnedReferralReward: 'Earned Referral Rewards',
    referralRewardCap: 'Referral Reward Cap',
    remainingClaimable: 'Remaining Claimable',
    usageProgress: 'Usage Progress',
    tip: 'Tip: Referral reward cap is 2x net deposit',
    
    // Node
    becomeNode: 'Become Node',
    nodeBadge: 'Node',
    nodeTitle: 'Buy Node',
    nodePrice: '3,000 USDT',
    nodeDesc: 'Enjoy node benefits',
    nodeApply: 'Buy Now',
    nodeProcessing: 'Processing...',
    nodeSuccess: 'Purchase successful',
    paymentFailed: 'Payment failed',
    nodeAgree: 'I have read and agree to the node agreement',
    nodeBenefits: 'Node Benefits',
    nodeBenefit1: 'Daily Dividends',
    nodeBenefit2: 'Referral Rewards',
    nodeBenefit3: 'Pool Earnings',
    nodeBenefit4: 'Governance Voting',
    nodeAddressLabel: 'Receiving Address',
    
    // Node Panel
    nodePanelTitle: 'Node Panel',
    nodePoolInfo: 'Node Pool Info',
    pendingTotal: 'Pending Total',
    nextDistribution: 'Next Distribution',
    myEarnings: 'My Earnings',
    miningReward: 'Mining Reward',
    claimedNodeReward: 'Claimed Node Reward',
    remainingCap: 'Remaining Cap',
    periodContribution: 'Period Contribution',
    estimatedNext: 'Estimated Next',
    distributionSoon: 'Soon',
    
    // Mining pool
    miningPool: 'Mining Pool',
    addLiquidity: 'Add Liquidity',
    addingLiquidity: 'Adding...',
    
    // Pool Panel
    poolPanelTitle: 'Pool Panel',
    totalPoolReward: 'Pool Reward',
    teamTotalMining: 'Team Total Mining',
    
    // Pool Health Monitor
    poolHealthTitle: 'Pool Health Monitor',
    qualifiedLabel: '✅ Qualified',
    notQualifiedLabel: '⚠️ Not Qualified',
    periodAssessment: 'Period {period} Assessment',
    remainingDaysText: '{days} days left',
    teamTotalMining: 'Team Total Mining',
    periodRequirementText: 'Period Requirement',
    progressText: 'Progress: {percent}%',
    childPoolsTitle: '📌 Child Pools (Deducted)',
    notQualifiedWarning: '⚠️ Performance not qualified! Need {requirement} SMA within {days} days, otherwise pool qualification will be cancelled.',
    soonExpireWarning: '⏰ Only {days} days left for next assessment, next period requirement: {nextRequirement} SMA',
    
    // Team
    teamNetwork: 'Team Network',
    
    // LP Dividends
    lpDividends: 'LP Dividends',
    pendingDividends: 'Pending Dividends',
    claimDividends: 'Claim Dividends',
    claimingDividends: 'Claiming...',
    dividendsTip: '💡 Only users who added liquidity (LP) can receive dividends',
    
    // Modals
    bindReferralModal: 'Bind Referrer',
    enterInviteCode: 'Enter invite code',
    inviteCodePlaceholder: 'Enter 6-digit code',
    pleaseEnterInviteCode: 'Please enter invite code',
    skip: 'Skip',
    bind: 'Bind',
    
    // Governance Panel
    governanceTitle: '🗳️ Governance',
    memberCountText: 'members',
    createProposal: 'Create Proposal',
    noActiveProposals: 'No active proposals',
    proposalId: 'Proposal ID',
    target: 'Target',
    amount: 'Amount',
    status: 'Status',
    votes: 'Votes',
    execute: 'Execute',
    cancel: 'Cancel',
    active: 'Active',
    executed: 'Executed',
    cancelled: 'Cancelled',
    yesVotes: 'Yes Votes',
    noVotes: 'No Votes',
    requiredVotes: 'Required Votes',
  },
  ja: {
    appName: 'スーパーカルチャーエージェント',
    connectWallet: 'ウォレット接続',
    disconnect: '切断',
    refresh: '更新',
    maintenance: 'メンテナンス中',
    copied: 'コピーしました',
    copyFailed: 'コピー失敗',
    pleaseConnectWallet: '先にウォレットを接続してください',
    pleaseEnterAmount: '金額を入力してください',
    pleaseEnterValidAddress: '有効なアドレスを入力してください',
    enterAmount: '金額を入力',
    enterAddress: 'アドレスを入力',
    close: '閉じる',
    loading: '読み込み中...',
    usdtBalance: 'USDT残高',
    smaBalance: 'SMA残高',
    currentPrice: '現在の価格',
    marketPrice: '市場価格',
    inviteCode: '招待コード',
    generateInviteCode: 'コード生成',
    copyInviteLink: 'リンクをコピー',
    generating: '生成中...',
    myAssets: '資産',
    depositPrincipal: '預入元本',
    remainingPrincipal: '残元本',
    pendingReward: '未払い報酬',
    totalReward: '総報酬',
    claimReward: '受け取る',
    claiming: '受取中...',
    deposit: '預入',
    depositing: '預入中...',
    withdraw: '引き出し',
    withdrawing: '引出中...',
    depositSuccess: '預入成功',
    depositFailed: '預入失敗',
    withdrawSuccess: '引出成功',
    withdrawFailed: '引出失敗',
    claimSuccess: '受取成功',
    claimFailed: '受取失敗',
    bindReferral: '紹介者を登録',
    bindReferralDesc: '紹介者のアドレス',
    binding: '登録中...',
    bindSuccess: '登録成功',
    bindFailed: '登録失敗',
    generateCodeSuccess: 'コード生成成功',
    generateCodeFailed: 'コード生成失敗',
    recommendReward: '紹介報酬',
    earnedReferralReward: '獲得紹介報酬',
    referralRewardCap: '紹介報酬上限',
    remainingClaimable: '残り受取可能額',
    usageProgress: '使用状況',
    tip: '紹介報酬上限は純預入額の2倍です',
    becomeNode: 'ノードになる',
    nodeBadge: 'ノード',
    nodeTitle: 'ノード購入',
    nodePrice: '3,000 USDT',
    nodeDesc: 'ノード特典を享受',
    nodeApply: '購入する',
    nodeProcessing: '処理中...',
    nodeSuccess: '購入成功',
    paymentFailed: '支払い失敗',
    nodeAgree: 'ノード契約に同意します',
    nodeBenefits: 'ノード特典',
    nodeBenefit1: '毎日配当',
    nodeBenefit2: '紹介報酬',
    nodeBenefit3: 'プール収益',
    nodeBenefit4: 'ガバナンス投票権',
    nodeAddressLabel: '受取アドレス',
    nodePanelTitle: 'ノードパネル',
    nodePoolInfo: 'ノードプール情報',
    pendingTotal: '未払い総額',
    nextDistribution: '次回配分',
    myEarnings: '収益',
    miningReward: 'マイニング報酬',
    claimedNodeReward: '受け取ったノード報酬',
    remainingCap: '残り上限',
    periodContribution: '今期貢献',
    estimatedNext: '次回予定',
    distributionSoon: '間もなく配分',
    miningPool: 'マイニングプール',
    addLiquidity: '流動性追加',
    addingLiquidity: '追加中...',
    poolPanelTitle: 'プールパネル',
    totalPoolReward: 'プール報酬',
    teamTotalMining: 'チーム総マイニング',
    poolHealthTitle: 'プール健全性モニター',
    qualifiedLabel: '✅ 達成',
    notQualifiedLabel: '⚠️ 未達成',
    periodAssessment: '第 {period} 期考核',
    remainingDaysText: '残り {days} 日',
    teamTotalMining: 'チーム総マイニング',
    periodRequirementText: '今期要件',
    progressText: '進捗: {percent}%',
    childPoolsTitle: '📌 子プール（実績控除済み）',
    notQualifiedWarning: '⚠️ 実績未達成！残り {days} 日以内に {requirement} SMA 達成が必要です。',
    soonExpireWarning: '⏰ 次回評価まで残り {days} 日、次期要件: {nextRequirement} SMA',
    teamNetwork: 'チームネットワーク',
    lpDividends: 'LP配当',
    pendingDividends: '未払い配当',
    claimDividends: '配当を受け取る',
    claimingDividends: '受取中...',
    dividendsTip: '💡 流動性（LP）を追加したユーザーのみが配当を受け取れます',
    bindReferralModal: '紹介者を登録',
    enterInviteCode: '招待コードを入力',
    inviteCodePlaceholder: '6桁のコードを入力',
    pleaseEnterInviteCode: '招待コードを入力してください',
    skip: 'スキップ',
    bind: '登録',
    governanceTitle: '🗳️ ガバナンス',
    memberCountText: '人のメンバー',
    createProposal: '提案を作成',
    noActiveProposals: 'アクティブな提案はありません',
    proposalId: '提案ID',
    target: 'ターゲット',
    amount: '金額',
    status: 'ステータス',
    votes: '票数',
    execute: '実行',
    cancel: 'キャンセル',
    active: 'アクティブ',
    executed: '実行済み',
    cancelled: 'キャンセル済み',
    yesVotes: '賛成票',
    noVotes: '反対票',
    requiredVotes: '必要票数',
  },
  ko: {
    appName: '슈퍼 컬처 에이전트',
    connectWallet: '지갑 연결',
    disconnect: '연결 해제',
    refresh: '새로고침',
    maintenance: '점검 중',
    copied: '복사됨',
    copyFailed: '복사 실패',
    pleaseConnectWallet: '지갑을 먼저 연결하세요',
    pleaseEnterAmount: '금액을 입력하세요',
    pleaseEnterValidAddress: '유효한 주소를 입력하세요',
    enterAmount: '금액 입력',
    enterAddress: '주소 입력',
    close: '닫기',
    loading: '로딩 중...',
    usdtBalance: 'USDT 잔액',
    smaBalance: 'SMA 잔액',
    currentPrice: '현재 가격',
    marketPrice: '시장 가격',
    inviteCode: '초대 코드',
    generateInviteCode: '코드 생성',
    copyInviteLink: '링크 복사',
    generating: '생성 중...',
    myAssets: '내 자산',
    depositPrincipal: '예치 원금',
    remainingPrincipal: '잔여 원금',
    pendingReward: '미지급 보상',
    totalReward: '총 보상',
    claimReward: '받기',
    claiming: '받는 중...',
    deposit: '예치',
    depositing: '예치 중...',
    withdraw: '인출',
    withdrawing: '인출 중...',
    depositSuccess: '예치 성공',
    depositFailed: '예치 실패',
    withdrawSuccess: '인출 성공',
    withdrawFailed: '인출 실패',
    claimSuccess: '받기 성공',
    claimFailed: '받기 실패',
    bindReferral: '추천인 등록',
    bindReferralDesc: '추천인 주소',
    binding: '등록 중...',
    bindSuccess: '등록 성공',
    bindFailed: '등록 실패',
    generateCodeSuccess: '코드 생성 성공',
    generateCodeFailed: '코드 생성 실패',
    recommendReward: '추천 보상',
    earnedReferralReward: '획득 추천 보상',
    referralRewardCap: '추천 보상 상한',
    remainingClaimable: '수령 가능 잔액',
    usageProgress: '사용 현황',
    tip: '추천 보상 상한은 순 예치금의 2배입니다',
    becomeNode: '노드 되기',
    nodeBadge: '노드',
    nodeTitle: '노드 구매',
    nodePrice: '3,000 USDT',
    nodeDesc: '노드 혜택',
    nodeApply: '구매하기',
    nodeProcessing: '처리 중...',
    nodeSuccess: '구매 성공',
    paymentFailed: '결제 실패',
    nodeAgree: '노드 약관에 동의합니다',
    nodeBenefits: '노드 혜택',
    nodeBenefit1: '일일 배당',
    nodeBenefit2: '추천 보상',
    nodeBenefit3: '풀 수익',
    nodeBenefit4: '거버넌스 투표권',
    nodeAddressLabel: '수취 주소',
    nodePanelTitle: '노드 패널',
    nodePoolInfo: '노드 풀 정보',
    pendingTotal: '미지급 총액',
    nextDistribution: '다음 분배',
    myEarnings: '내 수익',
    miningReward: '채굴 보상',
    claimedNodeReward: '수령한 노드 보상',
    remainingCap: '잔여 한도',
    periodContribution: '기간 기여도',
    estimatedNext: '다음 예상',
    distributionSoon: '곧 분배',
    miningPool: '마이닝 풀',
    addLiquidity: '유동성 추가',
    addingLiquidity: '추가 중...',
    poolPanelTitle: '풀 패널',
    totalPoolReward: '풀 보상',
    teamTotalMining: '팀 총 채굴량',
    poolHealthTitle: '풀 헬스 모니터',
    qualifiedLabel: '✅ 달성',
    notQualifiedLabel: '⚠️ 미달성',
    periodAssessment: '{period}차 평가',
    remainingDaysText: '{days}일 남음',
    teamTotalMining: '팀 총 채굴량',
    periodRequirementText: '本期要求',
    progressText: '진행률: {percent}%',
    childPoolsTitle: '📌 하위 풀 (실적 차감)',
    notQualifiedWarning: '⚠️ 실적 미달성! {days}일 내에 {requirement} SMA 필요',
    soonExpireWarning: '⏰ 다음 평가까지 {days}일 남음, 다음 요구사항: {nextRequirement} SMA',
    teamNetwork: '팀 네트워크',
    lpDividends: 'LP 배당',
    pendingDividends: '미지급 배당금',
    claimDividends: '배당금 받기',
    claimingDividends: '받는 중...',
    dividendsTip: '💡 유동성(LP)을 추가한 사용자만 배당금을 받을 수 있습니다',
    bindReferralModal: '추천인 등록',
    enterInviteCode: '초대 코드 입력',
    inviteCodePlaceholder: '6자리 코드 입력',
    pleaseEnterInviteCode: '초대 코드를 입력하세요',
    skip: '건너뛰기',
    bind: '등록',
    governanceTitle: '🗳️ 거버넌스',
    memberCountText: '명의 멤버',
    createProposal: '제안 생성',
    noActiveProposals: '진행 중인 제안 없음',
    proposalId: '제안 ID',
    target: '대상',
    amount: '금액',
    status: '상태',
    votes: '투표 수',
    execute: '실행',
    cancel: '취소',
    active: '진행 중',
    executed: '실행됨',
    cancelled: '취소됨',
    yesVotes: '찬성표',
    noVotes: '반대표',
    requiredVotes: '필요 표수',
  },
  vi: {
    appName: 'Siêu Trí Tuệ Văn Hóa',
    connectWallet: 'Kết nối ví',
    disconnect: 'Ngắt kết nối',
    refresh: 'Làm mới',
    maintenance: 'Bảo trì',
    copied: 'Đã sao chép',
    copyFailed: 'Sao chép thất bại',
    pleaseConnectWallet: 'Vui lòng kết nối ví trước',
    pleaseEnterAmount: 'Vui lòng nhập số tiền',
    pleaseEnterValidAddress: 'Vui lòng nhập địa chỉ hợp lệ',
    enterAmount: 'Nhập số tiền',
    enterAddress: 'Nhập địa chỉ',
    close: 'Đóng',
    loading: 'Đang tải...',
    usdtBalance: 'Số dư USDT',
    smaBalance: 'Số dư SMA',
    currentPrice: 'Giá hiện tại',
    marketPrice: 'Giá thị trường',
    inviteCode: 'Mã mời',
    generateInviteCode: 'Tạo mã',
    copyInviteLink: 'Sao chép link',
    generating: 'Đang tạo...',
    myAssets: 'Tài sản của tôi',
    depositPrincipal: 'Tiền gốc',
    remainingPrincipal: 'Tiền gốc còn lại',
    pendingReward: 'Phần thưởng chờ',
    totalReward: 'Tổng thưởng',
    claimReward: 'Nhận thưởng',
    claiming: 'Đang nhận...',
    deposit: 'Nạp tiền',
    depositing: 'Đang nạp...',
    withdraw: 'Rút tiền',
    withdrawing: 'Đang rút...',
    depositSuccess: 'Nạp tiền thành công',
    depositFailed: 'Nạp tiền thất bại',
    withdrawSuccess: 'Rút tiền thành công',
    withdrawFailed: 'Rút tiền thất bại',
    claimSuccess: 'Nhận thưởng thành công',
    claimFailed: 'Nhận thưởng thất bại',
    bindReferral: 'Đăng ký người giới thiệu',
    bindReferralDesc: 'Địa chỉ người giới thiệu',
    binding: 'Đang đăng ký...',
    bindSuccess: 'Đăng ký thành công',
    bindFailed: 'Đăng ký thất bại',
    generateCodeSuccess: 'Tạo mã thành công',
    generateCodeFailed: 'Tạo mã thất bại',
    recommendReward: 'Thưởng giới thiệu',
    earnedReferralReward: 'Thưởng giới thiệu đã nhận',
    referralRewardCap: 'Hạn mức thưởng giới thiệu',
    remainingClaimable: 'Còn lại có thể nhận',
    usageProgress: 'Tiến độ sử dụng',
    tip: 'Hạn mức thưởng giới thiệu bằng 2 lần tiền gửi ròng',
    becomeNode: 'Trở thành Node',
    nodeBadge: 'Node',
    nodeTitle: 'Mua Node',
    nodePrice: '3,000 USDT',
    nodeDesc: 'Hưởng quyền lợi node',
    nodeApply: 'Mua ngay',
    nodeProcessing: 'Đang xử lý...',
    nodeSuccess: 'Mua thành công',
    paymentFailed: 'Thanh toán thất bại',
    nodeAgree: 'Tôi đã đọc và đồng ý với thỏa thuận node',
    nodeBenefits: 'Quyền lợi Node',
    nodeBenefit1: 'Cổ tức hàng ngày',
    nodeBenefit2: 'Thưởng giới thiệu',
    nodeBenefit3: 'Thu nhập từ pool',
    nodeBenefit4: 'Quyền biểu quyết',
    nodeAddressLabel: 'Địa chỉ nhận tiền',
    nodePanelTitle: 'Bảng Node',
    nodePoolInfo: 'Thông tin Pool Node',
    pendingTotal: 'Tổng chờ',
    nextDistribution: 'Phân phối tiếp theo',
    myEarnings: 'Thu nhập của tôi',
    miningReward: 'Thưởng đào',
    claimedNodeReward: 'Đã nhận thưởng Node',
    remainingCap: 'Hạn mức còn lại',
    periodContribution: 'Đóng góp kỳ này',
    estimatedNext: 'Dự kiến lần sau',
    distributionSoon: 'Sắp phân phối',
    miningPool: 'Mining Pool',
    addLiquidity: 'Thêm thanh khoản',
    addingLiquidity: 'Đang thêm...',
    poolPanelTitle: 'Bảng Pool',
    totalPoolReward: 'Thưởng Pool',
    teamTotalMining: 'Tổng đào nhóm',
    poolHealthTitle: 'Theo dõi sức khỏe Pool',
    qualifiedLabel: '✅ Đạt',
    notQualifiedLabel: '⚠️ Không đạt',
    periodAssessment: 'Đánh giá kỳ {period}',
    remainingDaysText: 'Còn {days} ngày',
    teamTotalMining: 'Tổng đào nhóm',
    periodRequirementText: 'Yêu cầu kỳ này',
    progressText: 'Tiến độ: {percent}%',
    childPoolsTitle: '📌 Pool con (Đã trừ)',
    notQualifiedWarning: '⚠️ Không đạt! Cần {requirement} SMA trong {days} ngày',
    soonExpireWarning: '⏰ Còn {days} ngày cho đánh giá tiếp theo, yêu cầu kỳ sau: {nextRequirement} SMA',
    teamNetwork: 'Mạng lưới đội nhóm',
    lpDividends: 'Cổ tức LP',
    pendingDividends: 'Cổ tức chờ nhận',
    claimDividends: 'Nhận cổ tức',
    claimingDividends: 'Đang nhận...',
    dividendsTip: '💡 Chỉ người dùng đã thêm thanh khoản (LP) mới nhận được cổ tức',
    bindReferralModal: 'Đăng ký người giới thiệu',
    enterInviteCode: 'Nhập mã mời',
    inviteCodePlaceholder: 'Nhập mã 6 chữ số',
    pleaseEnterInviteCode: 'Vui lòng nhập mã mời',
    skip: 'Bỏ qua',
    bind: 'Đăng ký',
    governanceTitle: '🗳️ Quản trị',
    memberCountText: 'thành viên',
    createProposal: 'Tạo đề xuất',
    noActiveProposals: 'Không có đề xuất đang hoạt động',
    proposalId: 'ID đề xuất',
    target: 'Địa chỉ',
    amount: 'Số tiền',
    status: 'Trạng thái',
    votes: 'Phiếu bầu',
    execute: 'Thực thi',
    cancel: 'Hủy',
    active: 'Đang hoạt động',
    executed: 'Đã thực thi',
    cancelled: 'Đã hủy',
    yesVotes: 'Phiếu thuận',
    noVotes: 'Phiếu chống',
    requiredVotes: 'Số phiếu cần',
  },
  th: {
    appName: 'ซูเปอร์คัลเจอร์เอเจนต์',
    connectWallet: 'เชื่อมต่อกระเป๋า',
    disconnect: 'ตัดการเชื่อมต่อ',
    refresh: 'รีเฟรช',
    maintenance: 'กำลังซ่อมบำรุง',
    copied: 'คัดลอกแล้ว',
    copyFailed: 'คัดลอกล้มเหลว',
    pleaseConnectWallet: 'กรุณาเชื่อมต่อกระเป๋าก่อน',
    pleaseEnterAmount: 'กรุณากรอกจำนวน',
    pleaseEnterValidAddress: 'กรุณากรอกที่อยู่ที่ถูกต้อง',
    enterAmount: 'กรอกจำนวน',
    enterAddress: 'กรอกที่อยู่',
    close: 'ปิด',
    loading: 'กำลังโหลด...',
    usdtBalance: 'ยอด USDT',
    smaBalance: 'ยอด SMA',
    currentPrice: 'ราคาปัจจุบัน',
    marketPrice: 'ราคาตลาด',
    inviteCode: 'รหัสเชิญ',
    generateInviteCode: 'สร้างรหัส',
    copyInviteLink: 'คัดลอกลิงก์',
    generating: 'กำลังสร้าง...',
    myAssets: 'สินทรัพย์ของฉัน',
    depositPrincipal: 'เงินต้น',
    remainingPrincipal: 'เงินต้นคงเหลือ',
    pendingReward: 'รางวัลรอรับ',
    totalReward: 'รางวัลรวม',
    claimReward: 'รับรางวัล',
    claiming: 'กำลังรับ...',
    deposit: 'ฝาก',
    depositing: 'กำลังฝาก...',
    withdraw: 'ถอน',
    withdrawing: 'กำลังถอน...',
    depositSuccess: 'ฝากสำเร็จ',
    depositFailed: 'ฝากล้มเหลว',
    withdrawSuccess: 'ถอนสำเร็จ',
    withdrawFailed: 'ถอนล้มเหลว',
    claimSuccess: 'รับรางวัลสำเร็จ',
    claimFailed: 'รับรางวัลล้มเหลว',
    bindReferral: 'ลงทะเบียนผู้แนะนำ',
    bindReferralDesc: 'ที่อยู่ผู้แนะนำ',
    binding: 'กำลังลงทะเบียน...',
    bindSuccess: 'ลงทะเบียนสำเร็จ',
    bindFailed: 'ลงทะเบียนล้มเหลว',
    generateCodeSuccess: 'สร้างรหัสสำเร็จ',
    generateCodeFailed: 'สร้างรหัสล้มเหลว',
    recommendReward: 'รางวัลแนะนำ',
    earnedReferralReward: 'รางวัลแนะนำที่ได้รับ',
    referralRewardCap: 'วงเงินรางวัลแนะนำ',
    remainingClaimable: 'คงเหลือที่รับได้',
    usageProgress: 'ความคืบหน้า',
    tip: 'วงเงินรางวัลแนะนำคือ 2 เท่าของเงินฝากสุทธิ',
    becomeNode: 'เป็น Node',
    nodeBadge: 'Node',
    nodeTitle: 'ซื้อ Node',
    nodePrice: '3,000 USDT',
    nodeDesc: 'รับสิทธิประโยชน์ Node',
    nodeApply: 'ซื้อเลย',
    nodeProcessing: 'กำลังดำเนินการ...',
    nodeSuccess: 'ซื้อสำเร็จ',
    paymentFailed: 'ชำระเงินล้มเหลว',
    nodeAgree: 'ฉันได้อ่านและยอมรับข้อตกลง Node',
    nodeBenefits: 'สิทธิประโยชน์ Node',
    nodeBenefit1: 'เงินปันผลรายวัน',
    nodeBenefit2: 'รางวัลแนะนำ',
    nodeBenefit3: 'รายได้จาก pool',
    nodeBenefit4: 'สิทธิออกเสียง',
    nodeAddressLabel: 'ที่อยู่รับเงิน',
    nodePanelTitle: 'แผงโหนด',
    nodePoolInfo: 'ข้อมูลพูลโหนด',
    pendingTotal: 'ยอดรวมที่รอจ่าย',
    nextDistribution: 'การกระจายครั้งถัดไป',
    myEarnings: 'รายได้ของฉัน',
    miningReward: 'รางวัลการขุด',
    claimedNodeReward: 'รับรางวัลโหนดแล้ว',
    remainingCap: 'วงเงินคงเหลือ',
    periodContribution: 'ผลงานรอบนี้',
    estimatedNext: 'ประมาณการครั้งถัดไป',
    distributionSoon: 'กำลังจะกระจาย',
    miningPool: 'Mining Pool',
    addLiquidity: 'เพิ่มสภาพคล่อง',
    addingLiquidity: 'กำลังเพิ่ม...',
    poolPanelTitle: 'แผงพูล',
    totalPoolReward: 'รางวัลพูล',
    teamTotalMining: 'การขุดรวมทีม',
    poolHealthTitle: 'การตรวจสอบสุขภาพพูล',
    qualifiedLabel: '✅ บรรลุ',
    notQualifiedLabel: '⚠️ ไม่บรรลุ',
    periodAssessment: 'การประเมินครั้งที่ {period}',
    remainingDaysText: 'เหลือ {days} วัน',
    teamTotalMining: 'การขุดรวมทีม',
    periodRequirementText: 'ข้อกำหนดรอบนี้',
    progressText: 'ความคืบหน้า: {percent}%',
    childPoolsTitle: '📌 พูลรอง (หักผลงานแล้ว)',
    notQualifiedWarning: '⚠️ ผลงานไม่บรรลุ! ต้องการ {requirement} SMA ภายใน {days} วัน',
    soonExpireWarning: '⏰ เหลือ {days} วันสำหรับการประเมินครั้งถัดไป ข้อกำหนดรอบหน้า: {nextRequirement} SMA',
    teamNetwork: 'เครือข่ายทีม',
    lpDividends: 'เงินปันผล LP',
    pendingDividends: 'เงินปันผลรอรับ',
    claimDividends: 'รับเงินปันผล',
    claimingDividends: 'กำลังรับ...',
    dividendsTip: '💡 เฉพาะผู้ที่เพิ่มสภาพคล่อง (LP) เท่านั้นที่จะได้รับเงินปันผล',
    bindReferralModal: 'ลงทะเบียนผู้แนะนำ',
    enterInviteCode: 'กรอกรหัสเชิญ',
    inviteCodePlaceholder: 'กรอกรหัส 6 หลัก',
    pleaseEnterInviteCode: 'กรุณากรอกรหัสเชิญ',
    skip: 'ข้าม',
    bind: 'ลงทะเบียน',
    governanceTitle: '🗳️ การกำกับดูแล',
    memberCountText: 'สมาชิก',
    createProposal: 'สร้างข้อเสนอ',
    noActiveProposals: 'ไม่มีข้อเสนอที่กำลังดำเนินการ',
    proposalId: 'รหัสข้อเสนอ',
    target: 'ที่อยู่',
    amount: 'จำนวนเงิน',
    status: 'สถานะ',
    votes: 'คะแนนเสียง',
    execute: 'ดำเนินการ',
    cancel: 'ยกเลิก',
    active: 'กำลังดำเนินการ',
    executed: 'ดำเนินการแล้ว',
    cancelled: 'ยกเลิกแล้ว',
    yesVotes: 'เสียงเห็นด้วย',
    noVotes: 'เสียงไม่เห็นด้วย',
    requiredVotes: 'คะแนนที่ต้องการ',
  },
  es: {
    appName: 'Super Agente Cultural',
    connectWallet: 'Conectar Wallet',
    disconnect: 'Desconectar',
    refresh: 'Actualizar',
    maintenance: 'Mantenimiento',
    copied: 'Copiado',
    copyFailed: 'Error al copiar',
    pleaseConnectWallet: 'Conecte la wallet primero',
    pleaseEnterAmount: 'Ingrese la cantidad',
    pleaseEnterValidAddress: 'Ingrese una dirección válida',
    enterAmount: 'Ingrese cantidad',
    enterAddress: 'Ingrese dirección',
    close: 'Cerrar',
    loading: 'Cargando...',
    usdtBalance: 'Saldo USDT',
    smaBalance: 'Saldo SMA',
    currentPrice: 'Precio Actual',
    marketPrice: 'Precio Mercado',
    inviteCode: 'Código de Invitación',
    generateInviteCode: 'Generar Código',
    copyInviteLink: 'Copiar Enlace',
    generating: 'Generando...',
    myAssets: 'Mis Activos',
    depositPrincipal: 'Depósito',
    remainingPrincipal: 'Restante',
    pendingReward: 'Recompensa Pendiente',
    totalReward: 'Recompensa Total',
    claimReward: 'Reclamar',
    claiming: 'Reclamando...',
    deposit: 'Depositar',
    depositing: 'Depositando...',
    withdraw: 'Retirar',
    withdrawing: 'Retirando...',
    depositSuccess: 'Depósito exitoso',
    depositFailed: 'Depósito fallido',
    withdrawSuccess: 'Retiro exitoso',
    withdrawFailed: 'Retiro fallido',
    claimSuccess: 'Reclamo exitoso',
    claimFailed: 'Reclamo fallido',
    bindReferral: 'Registrar Referido',
    bindReferralDesc: 'Dirección del Referido',
    binding: 'Registrando...',
    bindSuccess: 'Registro exitoso',
    bindFailed: 'Registro fallido',
    generateCodeSuccess: 'Código generado',
    generateCodeFailed: 'Error al generar código',
    recommendReward: 'Recompensas por Referidos',
    earnedReferralReward: 'Recompensas Obtenidas',
    referralRewardCap: 'Límite de Recompensas',
    remainingClaimable: 'Disponible para Reclamar',
    usageProgress: 'Progreso',
    tip: 'El límite de recompensas es 2x del depósito neto',
    becomeNode: 'Convertirse en Nodo',
    nodeBadge: 'Nodo',
    nodeTitle: 'Comprar Nodo',
    nodePrice: '3,000 USDT',
    nodeDesc: 'Disfrute de beneficios exclusivos',
    nodeApply: 'Comprar Ahora',
    nodeProcessing: 'Procesando...',
    nodeSuccess: 'Compra exitosa',
    paymentFailed: 'Pago fallido',
    nodeAgree: 'He leído y acepto el acuerdo de nodo',
    nodeBenefits: 'Beneficios del Nodo',
    nodeBenefit1: 'Dividendos Diarios',
    nodeBenefit2: 'Recompensas por Referidos',
    nodeBenefit3: 'Ganancias del Pool',
    nodeBenefit4: 'Derecho a Voto',
    nodeAddressLabel: 'Dirección de Pago',
    nodePanelTitle: 'Panel de Nodo',
    nodePoolInfo: 'Información del Pool de Nodos',
    pendingTotal: 'Total Pendiente',
    nextDistribution: 'Próxima Distribución',
    myEarnings: 'Mis Ganancias',
    miningReward: 'Recompensa de Minería',
    claimedNodeReward: 'Recompensa de Nodo Reclamada',
    remainingCap: 'Capacidad Restante',
    periodContribution: 'Contribución del Período',
    estimatedNext: 'Próxima Estimación',
    distributionSoon: 'Próximamente',
    miningPool: 'Pool de Minería',
    addLiquidity: 'Agregar Liquidez',
    addingLiquidity: 'Agregando...',
    poolPanelTitle: 'Panel de Pool',
    totalPoolReward: 'Recompensa del Pool',
    teamTotalMining: 'Minería Total del Equipo',
    poolHealthTitle: 'Monitor de Salud del Pool',
    qualifiedLabel: '✅ Calificado',
    notQualifiedLabel: '⚠️ No Calificado',
    periodAssessment: 'Evaluación del Período {period}',
    remainingDaysText: '{days} días restantes',
    teamTotalMining: 'Minería Total del Equipo',
    periodRequirementText: 'Requisito del Período',
    progressText: 'Progreso: {percent}%',
    childPoolsTitle: '📌 Pools Hijos (Deducido)',
    notQualifiedWarning: '⚠️ Rendimiento no calificado! Se necesita {requirement} SMA en {days} días',
    soonExpireWarning: '⏰ Quedan {days} días para la próxima evaluación, requisito siguiente: {nextRequirement} SMA',
    teamNetwork: 'Red de Equipo',
    lpDividends: 'Dividendos LP',
    pendingDividends: 'Dividendos Pendientes',
    claimDividends: 'Reclamar Dividendos',
    claimingDividends: 'Reclamando...',
    dividendsTip: '💡 Solo los usuarios que agregaron liquidez (LP) pueden recibir dividendos',
    bindReferralModal: 'Registrar Referido',
    enterInviteCode: 'Ingrese código de invitación',
    inviteCodePlaceholder: 'Ingrese código de 6 dígitos',
    pleaseEnterInviteCode: 'Ingrese el código de invitación',
    skip: 'Omitir',
    bind: 'Registrar',
    governanceTitle: '🗳️ Gobernanza',
    memberCountText: 'miembros',
    createProposal: 'Crear Propuesta',
    noActiveProposals: 'No hay propuestas activas',
    proposalId: 'ID de Propuesta',
    target: 'Destino',
    amount: 'Cantidad',
    status: 'Estado',
    votes: 'Votos',
    execute: 'Ejecutar',
    cancel: 'Cancelar',
    active: 'Activo',
    executed: 'Ejecutado',
    cancelled: 'Cancelado',
    yesVotes: 'Votos a Favor',
    noVotes: 'Votos en Contra',
    requiredVotes: 'Votos Requeridos',
  },
};

export const getCurrentLanguage = () => {
  const savedLang = localStorage.getItem('language');
  if (savedLang && translations[savedLang]) return savedLang;
  const browserLang = navigator.language.split('-')[0];
  if (translations[browserLang]) return browserLang;
  return 'zh';
};

export const t = (lang, key) => {
  return translations[lang]?.[key] || translations.zh[key] || key;
};

export const changeLanguage = (lang, setLang) => {
  localStorage.setItem('language', lang);
  setLang(lang);
  window.location.reload();
};

export const setLanguage = (lang) => {
  localStorage.setItem('language', lang);
  window.location.reload();
};

export const languages = [
  { code: 'zh', name: '中文' },
  { code: 'en', name: 'English' },
  { code: 'ja', name: '日本語' },
  { code: 'ko', name: '한국어' },
  { code: 'vi', name: 'Tiếng Việt' },
  { code: 'th', name: 'ไทย' },
  { code: 'es', name: 'Español' }
];

export default translations;